import React, { useRef } from 'react';
import { useSelector } from "react-redux";
import styled from "styled-components";
import classnames from "classnames";
import { intersection } from "lodash";

import { SIDEPANEL_WIDTH } from "../../utils";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import ProgramGeneralMetrics from "../../sections/program/GeneralMetrics";
import ProgramMemberMetrics from "../../sections/program/MemberMetrics";
import SearchBar from "../SearchBar";
import { useReactToPrint } from 'react-to-print';

export default function index(props) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const {
    group_ids,
    group_categories,
    groups,
    all_resident_statuses,
    resident_statuses,
    all_group_categories,
    permissions,
    organization_name
  } = props;
  const { services } = props.permissions;
  const { showSidePanel } = useSelector((state) => state.config);
  const { selected } = useSelector((state) => state);
  return (
    <Container
      className={classnames("bg-white h-100 border-right border-bottom", {
        "border-left": !showSidePanel,
      })}
      style={{
        width: showSidePanel ? `calc(100% - ${SIDEPANEL_WIDTH})` : "100%",
      }}
    >
      <div className="border-bottom border-top">
        <div
          className="text-center pt-2 text-capitalize"
          style={{ fontWeight: "500" }}
        >
          {selected.name}
        </div>
        <div className="d-flex align-items-center justify-content-between w-100">
          <SearchBar
            group_ids={group_ids}
            groups={groups}
            handlePrint={handlePrint}
            group_categories={group_categories}
            all_group_categories={all_group_categories}
            resident_statuses={resident_statuses}
            all_resident_statuses={all_resident_statuses}
            organization_name={organization_name}
          />
        </div>
      </div>
      <div
        className="d-flex p-3 flex-column pb-5"
        style={{
          height: "calc(100% - 150px)",
          overflowY: "scroll",
          backgroundColor: "rgba(0,0,0,0.03)",
        }}
        ref={componentRef}
      >
        <Routes>
          <Route exact path="/organizations/:organization_name/outcomes" element={<ProgramGeneralMetrics {...props} />}>

          </Route>
          <Route exact path="/organizations/:organization_name/outcomes/member_data" element={<ProgramMemberMetrics {...props} />}>

          </Route>
        </Routes>
      </div>
    </Container>
  );
}

const Container = styled.div`
  width: calc(100% - ${SIDEPANEL_WIDTH});
  @media (max-width: 990px) {
    width: 100% !important;
    border-left: 1px solid rgb(207, 216, 220);
  }
`;
